module.exports = __webpack_public_path__ + "static/media/musicapp.63d9ee9f.png";